import { render, staticRenderFns } from "./ImageBase.vue?vue&type=template&id=0d58cb8d&scoped=true&lang=pug&"
import script from "./ImageBase.vue?vue&type=script&lang=ts&"
export * from "./ImageBase.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d58cb8d",
  null
  
)

export default component.exports